import { createContext } from 'react'

import {
  LAYOUT_OPTIONS_DEFAULT,
} from '../constants'

import {
  ILayout_Render_Context_With_Options,
} from '../types/layout'

const RenderContext = createContext<ILayout_Render_Context_With_Options>({
  project: '',
  token: '',
  disableLinks: true,
  preview: false,
  values: {},
  options: LAYOUT_OPTIONS_DEFAULT,
})

export default RenderContext